import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import EventsAwardsHeader from "@events-awards/EventAwardsHeader";
import EventsAwardsNavigationBar from "@events-awards/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import {
  EVENTS_AWARDS_SIA_LABEL,
  EVENTS_AWARDS_SIA_PATH,
} from "@events-awards/utils/constants";
import {
  getStaticPageTitle,
  renderSIAStaticComponents,
} from "@events-awards/utils/helpers";
import { AwardType } from "@events-awards/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

import SIAFooter from "./SIAFooter";

type SIAStaticPageProps = {
  /** The url string to get url at SIA static page. */
  urlPath: string;
};

/**
 * component to render SIA static navigation pages
 */
const SIAStaticPage = ({ urlPath }: SIAStaticPageProps): React.ReactElement => {
  const adBlockDetected = useDetectAdBlock();

  const segments = urlPath.split("/");
  const page = segments[segments.length - 1];
  const StaticLayout = renderSIAStaticComponents(page);

  return (
    <div className="w-full" data-testid="sia-static-page-component">
      <AdSettings
        adNames={["lb1", "prestitial", "catfish", "abm"]}
        path={EVENTS_AWARDS_SIA_PATH}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title="Sustainability Impact Awards"
        level2="events awards"
        adblocker={adBlockDetected ? 1 : 0}
      />

      <MetaTags
        title={getStaticPageTitle(urlPath) + "  - THE BUSINESS TIMES"}
        description={`THE BUSINESS TIMES ${EVENTS_AWARDS_SIA_LABEL} - Find ${EVENTS_AWARDS_SIA_LABEL} News & Headlines, insight and analysis in Singapore, Asia-Pacific & global markets news at The Business Times.`}
        ogType="website"
        slug={EVENTS_AWARDS_SIA_PATH}
      />

      <EventsAwardsHeader />

      <Container>
        <div className="mb-8 w-full justify-center px-0 text-left text-gray-850">
          <EventsAwardsNavigationBar awardType={AwardType.SIA} />

          <>{StaticLayout ? <StaticLayout /> : null}</>
        </div>
      </Container>

      <SIAFooter />

      <Ad adType="catfish" />

      <Ad adType="abm" />

      <Ad adType="prestitial" />
    </div>
  );
};
export default SIAStaticPage;
